import gql from 'graphql-tag'
import GqlClient from '../lib/GqlClient'
import Logger from '@/lib/Logger'

class ClInstance {
  static attributeNames() {
    return ['id', 'title'] //workspace_id ?
  }
  // -
  static getClean(dirtyObj) {
    Logger.debug('dirtyObj', dirtyObj)
    let cleanObject = {}
    this.attributeNames().forEach(attrname => {
      if (attrname in dirtyObj) {
        cleanObject[attrname] = dirtyObj[attrname]
      }
    })
    Logger.debug('cleanObject:', cleanObject)
    return cleanObject
  }

  static select({ get, by, onChange, onError }) {
    return GqlClient.activeQuery({
      retrieveGql: {
        dataKey: 'clInstances',
        query: gql`
          query($clMasterId: ID!) {
            clInstances (clMasterId: $clMasterId)
            ${get}
          }`,
        variables: {
          clMasterId: by.clMasterId,
        },
      },
      listenGql: {
        dataKey: 'clMasterInstancesChanged',
        query: gql`
          subscription {
            clMasterInstancesChanged (clMasterId: ${by.clMasterId}) {
              id
            }
          }`,
      },
      onDataChange: data => {
        Logger.debug('ClInstances.stdQuery CHANGED:', by, data)
        onChange(data)
      },
      onError: error => onError(error),
    })
  }

  static find({ get, by, onChange, onError }) {
    // Logger.debug('ClInstance.find', get, by, onChange)
    return GqlClient.activeQuery({
      retrieveGql: {
        dataKey: 'clInstance',
        query: gql`
          query($clInstanceId: ID!) {
              clInstance (clInstanceId: $clInstanceId)
              ${get}
          }`,
        variables: {
          clInstanceId: by.id,
        },
      },
      listenGql: {
        dataKey: 'clInstanceChanged',
        query: gql`
          subscription {
            clInstanceChanged (clInstanceId: ${by.id}) {
              id
            }
          }`,
      },
      onDataChange: data => {
        Logger.debug('ClInstance CHANGED:', by, data)
        onChange(data)
      },
      onError: error => onError(error),
    })
  }

  static notifyLeave(instanceId) {
    Logger.debug('ClInstance.notifyLeave', instanceId)
    return GqlClient.runMutation({
      dataKey: 'clInstanceLeave',
      mutation: gql`
        mutation($instanceId: ID!) {
          clInstanceLeave(clInstanceId: $instanceId) {
            info
          }
        }
      `,
      variables: {
        instanceId,
      },
    })
  }

  static userAccess({ clInstanceId, userId, onChange, onError }) {
    Logger.debug('clInstanceId', clInstanceId)
    return GqlClient.activeQuery({
      retrieveGql: {
        dataKey: 'clInstanceAccess',
        query: gql`
          query($clInstanceId: ID!, $userId: ID!) {
            clInstanceAccess(clInstanceId: $clInstanceId, userId: $userId) {
              accessType
            }
          }
        `,
        variables: {
          clInstanceId: clInstanceId,
          userId: userId,
        },
      },
      listenGql: {
        dataKey: 'clInstanceAccessChanged',
        query: gql`
          subscription {
            clInstanceAccessChanged (clInstanceId: ${clInstanceId}, userId: ${userId}) {
              id
            }
          }`,
      },
      onDataChange: data => {
        Logger.debug('clInstanceAccess CHANGED:', clInstanceId, userId, data)
        onChange(data)
      },
      onError: error => onError(error),
    })
  }

  // static newInstance (clInstance) {
  //   Logger.debug('ClInstanceMgr::newInstance()', clInstance)
  //   ClInstance.addNew({clInstanceId: clInstance.id})
  // }

  static async create(instanceNew) {
    Logger.debug('ClInstance.create', instanceNew)
    return GqlClient.runMutation({
      dataKey: 'clInstanceAdd',
      mutation: gql`
        mutation($input: ClInstanceInput!) {
          clInstanceAdd(input: $input) {
            id
          }
        }
      `,
      variables: {
        input: instanceNew,
      },
    })
  }

  /* static async duplicate(instanceNew) {
    Logger.debug('ClInstance.duplicate', instanceNew)
    return GqlClient.runMutation({
      mutation: gql`
        mutation($input: ClInstanceInput!) {
          clInstanceDuplicate(input: $input) {
            id
          }
        }
      `,
      variables: {
        input: instanceNew,
      },
    })
  } */

  static save(instance) {
    Logger.debug('ClInstance.save', instance)
    return GqlClient.runMutation({
      dataKey: 'clInstanceChange',
      mutation: gql`
        mutation($input: ClInstanceInput!) {
          clInstanceChange(input: $input) {
            clInstance {
              id
              title
            }
          }
        }
      `,
      variables: {
        input: ClInstance.getClean(instance),
      },
    })
  }

  static archive(instance) {
    Logger.debug('ClInstance.archive', instance)
    return GqlClient.runMutation({
      dataKey: 'clInstanceArchive',
      mutation: gql`
        mutation($id: ID!) {
          clInstanceArchive(clInstanceId: $id) {
            info
          }
        }
      `,
      variables: {
        id: instance.id,
      },
    })
  }

  static unarchive(instance) {
    Logger.debug('ClInstance.unarchive', instance)
    return GqlClient.runMutation({
      dataKey: 'clInstanceUnarchive',
      mutation: gql`
        mutation($id: ID!) {
          clInstanceUnarchive(clInstanceId: $id) {
            info
          }
        }
      `,
      variables: {
        id: instance.id,
      },
    })
  }

  static delete(instanceId) {
    Logger.debug('delete', instanceId)
    return GqlClient.runMutation({
      dataKey: 'clInstanceDelete',
      mutation: gql`
        mutation($id: ID!) {
          clInstanceDelete(clInstanceId: $id) {
            info
          }
        }
      `,
      variables: {
        id: instanceId,
      },
    })
  }

  static entryMove(instanceEntryId, oldIndex, newIndex) {
    Logger.debug('ClInstance.entryMove', instanceEntryId, oldIndex, newIndex)
    return GqlClient.runMutation({
      dataKey: 'clInstanceEntryMove',
      mutation: gql`
        mutation($id: ID!, $oldIndex: Int!, $newIndex: Int!) {
          clInstanceEntryMove(id: $id, oldIndex: $oldIndex, newIndex: $newIndex) {
            clInstanceEntry {
              id
              clEntry {
                id
                orderPosition
              }
            }
          }
        }
      `,
      variables: {
        id: instanceEntryId,
        oldIndex,
        newIndex,
      },
    })
  }
}

export default ClInstance
